import { ReactNode } from 'react'
import Styles from './StatusPillV2.module.scss'
import { Pill } from 'components/Pill/Pill'
import cx from 'classnames'

export type PostStatus =
  | 'draft'
  | 'review'
  | 'connect'
  | 'scheduled'
  | 'approved'
  | 'posted'
  | 'failed'
  | 'paused'
  | 'updating'
  | 'new'

export interface StatusPillV2Props {
  label: ReactNode
  status: PostStatus
  testId: string
  size?: 'xs' | 'sm' | 'md'
}

export const StatusPillV2 = ({ label, status, testId, size = 'md' }: StatusPillV2Props) => {
  return (
    <div className={Styles.statusPillV2} data-testid={testId}>
      <Pill className={cx(Styles.pill, Styles[status], Styles[size])} size={size}>
        {label}
      </Pill>
    </div>
  )
}
